<template>
  <div class="region-heat-map">
    <div class="map-wrap">
      <TiandiMap
        class="map-container-inner"
        height="360px"
        :center="mapCenter"
        :zoom="14"
        :heat-points="heatPoints"
        :auto-fit="heatPoints.length > 0"
        :initial-markers="[]"
        :show-toolbar="false"
      />
      <div class="heat-legend">
        <span class="heat-legend-label">低</span>
        <div class="heat-legend-bar" />
        <span class="heat-legend-label">高</span>
      </div>
    </div>
  </div>
</template>

<script>
import TiandiMap from '@/components/tiandi-map/index.vue';

export default {
  name: 'RegionHeatMap',
  components: {
    TiandiMap
  },
  props: {
    initialLnglat: {
      type: Array,
      default() {
        return [105.2593, 37.6294];
      }
    },
    regionList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    mapCenter() {
      return this.initialLnglat && this.initialLnglat.length >= 2
        ? this.initialLnglat
        : [105.2593, 37.6294];
    },
    heatPoints() {
      const list = this.regionList || [];
      const center = this.mapCenter;
      const n = list.length;

      return list.map((item, index) => {
        const value = Number(item.value) || 0;
        const angle = (index / Math.max(n, 1)) * Math.PI * 2;
        const ring = 0.00035 + (index % 7) * 0.00045;

        return {
          name: item.name,
          value: Math.max(1, value),
          longitude: center[0] + Math.cos(angle) * ring * (1 + (index % 3) * 0.15),
          latitude: center[1] + Math.sin(angle) * ring * (1 + (index % 3) * 0.15)
        };
      });
    }
  }
};
</script>

<style scoped lang="scss">
.region-heat-map {
  width: 100%;
}

.map-wrap {
  position: relative;
  width: 100%;
  height: 360px;
  border-radius: 4px;
  overflow: hidden;
}

.map-container-inner {
  width: 100%;
  height: 100%;
}

.heat-legend {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 120;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  font-size: 12px;
  color: #606266;
}

.heat-legend-label {
  white-space: nowrap;
}

.heat-legend-bar {
  width: 120px;
  height: 10px;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    #e3f2fd 0%,
    #81d4fa 35%,
    #29b6f6 65%,
    #01579b 100%
  );
}
</style>
